import options from './chart-water-detector.component';

export default {
    selector: 'dtChartWaterDetector',
    options
};
